// extracted by mini-css-extract-plugin
module.exports = {"hidden":"eventBanner_hidden__KhwWm","textEmphasis":"eventBanner_textEmphasis__Ou5NT","dChampsEventBanner":"eventBanner_dChampsEventBanner__v51YX"};